module.exports = __webpack_public_path__ + "static/campaign-highlights-3556616588fe35f24d2df14e313c2298.jpg";